import { render, staticRenderFns } from "./SubMenu.vue?vue&type=template&id=679078c5&scoped=true"
import script from "./SubMenu.js?vue&type=script&lang=js&external"
export * from "./SubMenu.js?vue&type=script&lang=js&external"
import style0 from "./SubMenu.scss?vue&type=style&index=0&id=679078c5&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679078c5",
  null
  
)

export default component.exports